import { PLACEHOLDER_POST_TITLE } from './post-title';

import { useInspector } from '@/components/ui/inspector/hooks/useInspector';

export interface PristineDraftCandidate {
  status?: string | null;
  content?: string | null;
  title?: string | null;
  media_urls?: string[] | null;
  platform_captions?: unknown;
  plan_slot_id?: string | null;
  campaign_id?: string | null;
}

function hasText(value: string | null | undefined): boolean {
  return Boolean(value && value.trim());
}

function hasPlatformCaptions(value: unknown): boolean {
  if (!value || typeof value !== 'object') return false;
  return Object.values(value as Record<string, unknown>).some(
    (entry) => typeof entry === 'string' && entry.trim().length > 0,
  );
}

export function isPristineManualDraft(post: PristineDraftCandidate | null | undefined): boolean {
  if (!post) return false;
  if (post.status !== 'draft') return false;
  if (hasText(post.content)) return false;
  if ((post.media_urls?.length ?? 0) > 0) return false;
  if (hasPlatformCaptions(post.platform_captions)) return false;
  if (post.plan_slot_id || post.campaign_id) return false;
  const title = post.title?.trim();
  if (title && title.toLowerCase() !== PLACEHOLDER_POST_TITLE.toLowerCase()) return false;
  return true;
}

function isPostOpen(postId: string): boolean {
  return useInspector
    .getState()
    .stack.some((subject) => subject.kind === 'post' && subject.postId === postId);
}

export function watchAbandonedDraft(
  postId: string,
  onAbandoned: (postId: string) => void | Promise<void>,
  delayMs = 2500,
): void {
  const store = useInspector as unknown as Partial<typeof useInspector>;
  if (typeof store.subscribe !== 'function') return;
  const unsubscribe = store.subscribe(() => {
    if (isPostOpen(postId)) return;
    unsubscribe();
    window.setTimeout(() => {
      if (isPostOpen(postId)) return;
      void onAbandoned(postId);
    }, delayMs);
  });
}
